var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 27C5.83 27 0 20.9458 0 13.5C0 6.05423 5.83 0 13 0C20.17 0 26 6.05423 26 13.5C26 20.9458 20.17 27 13 27ZM13 1.03846C6.385 1.03846 1 6.63058 1 13.5C1 20.3694 6.385 25.9615 13 25.9615C19.615 25.9615 25 20.3694 25 13.5C25 6.63058 19.615 1.03846 13 1.03846Z",
    fill: "url(#paint0_linear_656_482)",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 17.6538C12.1701 17.6538 11.4951 16.9788 11.4551 16.1221L11.0501 6.87457C11.0301 6.43322 11.1801 6.01264 11.4751 5.69072C11.7701 5.3688 12.1651 5.19226 12.5951 5.19226H13.4051C13.8301 5.19226 14.2301 5.3688 14.5251 5.69072C14.8201 6.01264 14.9701 6.43322 14.9501 6.87457L14.5451 16.1221C14.5051 16.984 13.8301 17.6538 13.0001 17.6538ZM12.5951 6.23072C12.4451 6.23072 12.3051 6.29303 12.2001 6.40726C12.0951 6.52149 12.0451 6.66688 12.0501 6.82264L12.4551 16.0701C12.4701 16.3713 12.7101 16.6101 13.0001 16.6101C13.2901 16.6101 13.5351 16.3713 13.5451 16.0701L13.9501 6.82264C13.9551 6.66688 13.9051 6.5163 13.8001 6.40726C13.6951 6.29303 13.5551 6.23072 13.4051 6.23072H12.5951Z",
    fill: "url(#paint1_linear_656_482)",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.8076C12.175 21.8076 11.5 21.1067 11.5 20.25C11.5 19.3932 12.175 18.6923 13 18.6923C13.825 18.6923 14.5 19.3932 14.5 20.25C14.5 21.1067 13.825 21.8076 13 21.8076ZM13 19.7307C12.725 19.7307 12.5 19.9644 12.5 20.25C12.5 20.5355 12.725 20.7692 13 20.7692C13.275 20.7692 13.5 20.5355 13.5 20.25C13.5 19.9644 13.275 19.7307 13 19.7307Z",
    fill: "url(#paint2_linear_656_482)",
    fillOpacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_656_482",
    x1: 13,
    y1: 0,
    x2: 13,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35FFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_656_482",
    x1: 13.0001,
    y1: 5.19226,
    x2: 13.0001,
    y2: 17.6538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35FFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_656_482",
    x1: 13,
    y1: 18.6923,
    x2: 13,
    y2: 21.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35FFB6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientExclamation);
export default __webpack_public_path__ + "static/media/gradient-exclamation.a28ce1b10a53c316f17d59ceca4ad924.svg";
export { ForwardRef as ReactComponent };